// src/Apis/index.js
import axios from "axios";
import { showToast } from "../utils/toast";

const BASE_URL = process.env.REACT_APP_BASE_URL || "https://cspv0tmvph.execute-api.us-east-1.amazonaws.com/production";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add response interceptor for better error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);
    
    // Handle 401 Unauthorized errors globally
    if (error.response?.status === 401) {
      // Show toast notification
      showToast('Session expired. Please log in again.', 'error');
      
      // Remove token from storage
      localStorage.removeItem('token');
      
      // Redirect to login after a short delay
      setTimeout(() => {
        window.location.href = '/admin/login';
      }, 2000);
    }
    
    return Promise.reject(error);
  }
);

export const contactUs = (formData) => {
  return api.post("/contact", formData);
};

export const adminLogin = (credentials) => {
  return api.post("/admin/login", credentials);
};

export default api;